import React from 'react'
import Hero from '../components/Hero'
import HomeSection from '../components/HomeSection'
import Qoute from '../components/Qoute'

export default function Home() {
  return (
    <>
        <Hero />
        <HomeSection />
        <Qoute />

    </>
  )
}
